import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { CLIENTS_ROUTE_VALIDATE_SEARCH_CONFIG } from '@/pages/Clients/ClientsPage.config';

// Union of the SA and agency persona configs (ENT-89/ENT-263 — T02) — both
// branches render under this one route, so validateSearch must accept both
// personas' filter URL keys or TanStack Router silently drops whichever
// isn't recognised. See ClientsPage.config.ts for the union rationale.
export const Route = createFileRoute('/clients/')({
  validateSearch: generateValidateSearch(CLIENTS_ROUTE_VALIDATE_SEARCH_CONFIG),
});
